// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"Add_style_clearfix__2wCei","tableBox":"Add_style_tableBox__1X-Cg"};